import React from "react"
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { ANOTATOR_DEFAULT_TEXT_SIZE } from "../tools/Contants";
import { FileDownload, Save } from '@mui/icons-material';


export type SettingsProps = {
    onChangeDocumentTextSize: () => void,
    onSaveAnnotations: () => void,
    onExportAnnotations: () => void
}

export default function Settings (props: SettingsProps)  {
    
    const getCurrentSize = ():string =>{
        return (sessionStorage.getItem('textSize') !== null)?sessionStorage.getItem('textSize')!:ANOTATOR_DEFAULT_TEXT_SIZE;
    }

    const [currentSize, setCurrentSize] = React.useState(getCurrentSize());
      
    const saveNewSize = (newSize:number) =>{
        setCurrentSize(newSize.toString());
        sessionStorage.setItem('textSize', newSize.toString());
        props.onChangeDocumentTextSize();
    } 
    const handleAddSize = () =>{
       var currsize = getCurrentSize();
       if(parseInt(currsize) < 25){
            var newSize= parseInt(currsize) + 1;
            saveNewSize(newSize);
       }else
        setCurrentSize(currsize);

    }

    const handleLessSize = () =>{
        var currsize = getCurrentSize();
        
        if(parseInt(currsize) > 10){
            var newSize= parseInt(currsize) - 1;
            saveNewSize(newSize);
        }else
            setCurrentSize(currsize);
    }

    
 return <div className="area-details-settings">
        <div className="area-settings-number-field">
            <button type="button" className="button-option-small button-option-unselected-text " onClick={props.onSaveAnnotations}>
                <Save className="area-documents-add-icon-text"></Save>
            </button>
             <button type="button" className="button-option-small button-option-unselected-text " onClick={props.onExportAnnotations}>
                <FileDownload className="area-documents-add-icon-text"></FileDownload>
            </button>
            <p className="area-settings-label area-settings-label-left-margin">Text Size </p>
            <button type="button" className="button-option-small button-option-unselected-text " onClick={handleLessSize}>
                <HorizontalRuleOutlinedIcon className="area-documents-add-icon-text"></HorizontalRuleOutlinedIcon>
            </button>
            <p className="area-settings-label area-settings-label-fit">{currentSize} </p>
            <button type="button" className="button-option-small button-option-unselected-text " onClick={handleAddSize}>
                <AddOutlinedIcon className="area-documents-add-icon-text"></AddOutlinedIcon>
            </button>

           
           
        </div>
    </div>
}